// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".status-label[data-v-292f44ba]{position:absolute;top:61px;left:0;display:flex;flex-direction:column;justify-content:center;width:100%;letter-spacing:.6px;text-transform:uppercase;height:38px;text-align:center;font-weight:700;font-size:12px;line-height:18px}.status-label.active[data-v-292f44ba]{background:var(--q4s-green-100)}.status-label.inactive[data-v-292f44ba]{background:var(--q4s-paper-100)}", ""]);
// Exports
module.exports = exports;
